import { Component, Input, OnInit, ViewChild } from '@angular/core'
import { Assistance } from 'src/app/models/assistance'
import { ModalController } from '@ionic/angular'
import { GridComponent, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids'
import { FinanceService } from '../../../services/domain/finance.service'
import { AssistanceEditorModalService } from '../assistance-editor-modal/assistance-editor-modal.service'
import { Observable } from 'rxjs'
import { AssistanceService } from '../../../services/domain/assistance/assistance.service'
import { AssistanceStatusName } from '../../../models/assistanceStatus'
import { ListAssistanceLockService } from '../assistance-list-new/list-assistance-lock.service'
import { switchMap } from 'rxjs/operators'

enum SimpleAssistanceListButton {
  bill,
  cancel,
  delete,
}

@Component({
  selector: 'app-simple-assistance-list',
  templateUrl: './simple-assistance-list.component.html',
  styleUrls: ['./simple-assistance-list.component.scss'],
  standalone: false,
})
export class SimpleAssistanceListComponent implements OnInit {
  TAG = 'SimpleAssistanceListComponent'
  @Input() initialAssistances: Assistance[]
  @Input() assistances$: Observable<Assistance[]>
  @Input() headerText: string
  @Input() instructionText: string

  @ViewChild('grid') grid: GridComponent

  assistancesToRender$: Observable<Assistance[]>
  lastClickedButton: SimpleAssistanceListButton = null

  Assistance = Assistance
  BTNS = SimpleAssistanceListButton
  console = console

  constructor(
    private modalCtrl: ModalController,
    private financeService: FinanceService,
    private assistanceEditorModalService: AssistanceEditorModalService,
    private assistanceService: AssistanceService,
    private lockerService: ListAssistanceLockService,
  ) {}

  async ngOnInit() {
    this.assistancesToRender$ = this.assistances$.pipe(
      switchMap((assistances) => this.lockerService.syncAfterLockChanges$(assistances)),
    )
  }

  close() {
    this.modalCtrl.dismiss()
  }

  rowClicked(event: RowSelectEventArgs) {
    const assistance = this.grid.getSelectedRecords()[0] as Assistance

    if (this.lastClickedButton !== null && this.lastClickedButton !== undefined) {
      switch (this.lastClickedButton) {
        case SimpleAssistanceListButton.bill:
          this.billAssistanceClicked(assistance)
          break
        case SimpleAssistanceListButton.cancel:
          this.cancelAssistanceClicked(assistance)
          break
        case SimpleAssistanceListButton.delete:
          this.deleteAssistanceClicked(assistance)
          break
      }
    } else {
      this.assistanceEditorModalService.openEditor(assistance).then((modal) =>
        modal.onDidDismiss().then((data) => {
          console.log('dismissedModal', data)
          console.log('onDidDismiss')
        }),
      )
    }

    setTimeout(() => {
      this.grid.clearSelection()
      this.clearLastClickedButton()
    })
  }

  async billAssistanceClicked(a: Assistance) {
    await this.lock(a)

    await this.financeService.billAssistances([a])
  }

  async cancelAssistanceClicked(a: Assistance) {
    this.lock(a)

    const alert = await this.assistanceEditorModalService.changeStatusWithDialog(
      a,
      AssistanceStatusName.CANCELED,
      true,
      async (assistanceWithChangedStatus) => {
        a = (await this.assistanceService.update(assistanceWithChangedStatus)) as Assistance
        this.unlock(a)
      },
    )
    await alert.onDidDismiss().then((data) => {
      console.log('dismiss', data)
      if (data.role === 'cancel' || data.role === 'backdrop') this.lockerService.unlock(a)
    })
  }

  async deleteAssistanceClicked(a: Assistance) {
    await this.lock(a)

    await this.assistanceService.deleteWithConfirmation(a)
  }

  buttonClicked(btn: SimpleAssistanceListButton) {
    this.lastClickedButton = btn
  }

  private clearLastClickedButton() {
    this.lastClickedButton = null
  }

  private lock(a: Assistance) {
    this.lockerService.lock(a)
    this.grid.dataSource = { ...this.grid.dataSource }
  }

  private unlock(a: Assistance) {
    this.lockerService.unlock(a)
    this.grid.dataSource = { ...this.grid.dataSource }
  }
}
